import React, { useState } from "react";
import { Modal, Upload, Typography } from "antd";
import { IoClose } from "react-icons/io5";

import { MdOutlineArrowOutward } from "react-icons/md";
import PrimaryButton from "../Forms/PrimaryButton";
import { useGlobalModal } from "../../context/SuccessModalProvider";
import { BsTrash3 } from "react-icons/bs";

const { Dragger } = Upload;
const { Title } = Typography;

export default function FileUploadModal({
  open,
  onClose,
  onUpload,
  title = "Upload File",
  fileTypes = [],
  buttonText = "Upload",
  icon,
  maxFiles = 1,
  loading = false,
  fileTypeLabel = "",
}) {
  const { showPopup } = useGlobalModal();
  const [fileList, setFileList] = useState([]);
  const draggerProps = {
    name: "file",
    multiple: maxFiles > 1,
    fileList,
    beforeUpload: () => false,
    onChange(info) {
      const filteredFiles = info.fileList.filter((file) => {
        if (!fileTypes.length) return true;
        const ext = file.name.split(".").pop().toLowerCase();
        const mime = file.type?.toLowerCase();
        if (!fileTypes.includes("." + ext) && !fileTypes.includes(mime)) {
          return showPopup({
            title: null,
            content: (
              <span className="custom-modal-title">Please upload only {fileTypeLabel} files.</span>
            ),
            onOk: () => console.log("Confirmed!"),
            className: "custom-success-modal",
          });
        }
        return true;
      });
      if (filteredFiles.length > maxFiles) {
        filteredFiles.splice(0, filteredFiles.length - maxFiles);
      }
      setFileList(filteredFiles);
    },
  };

  React.useEffect(() => {
    if (!onClose) return;
    return () => {
      setFileList([]);
    };
  }, [onClose]);

  const handleButtonClick = () => {
    onUpload(fileList);
    setFileList([]);
  };

  return (
    <Modal
      className="form-css-2 custom-modal"
      open={open}
      footer={null}
      onCancel={onClose}
      centered
      styles={{
        mask: { background: "rgba(0,0,0,0.3)" },
      }}
    >
      <div className="flex justify-between items-center">
        <Title
          level={2}
          className="text-xl font-semibold text-gray-800 font-abhaya !mb-3"
          style={{ display: "inline-block" }}
        >
          {title}
        </Title>
      </div>

      {/* File Drop Zone */}
      <Dragger
        {...draggerProps}
        className="w-full h-[200px] flex items-center justify-center rounded-3xl border border-black border-dashed"
        showUploadList={false}
        accept={fileTypes}
      >
        <div className="flex flex-col items-center justify-center text-center w-full h-full">
          {icon ? icon : <img src="/assets/icons/gallery.png" alt="upload" className="w-16 mb-3" />}

          {/* Show file names if files are selected */}
          {fileList.length > 0 ? (
            <div className="mt-2 flex flex-col gap-2">
              {fileList.map((file, index) => (
                <div
                  key={file.uid || index}
                  className="flex justify-between items-center bg-gray-100 rounded px-3 py-2 gap-3"
                >
                  <span className="truncate text-gray-800">{file.name}</span>
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      setFileList((prev) => prev.filter((_, i) => i !== index));
                    }}
                    className="text-red-500 hover:text-red-700"
                  >
                    <BsTrash3 />
                  </button>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-gray-600 font-abhaya">
              Drag your file here or{" "}
              <span className="text-[#A33434] cursor-pointer font-abhaya">browse</span>
            </p>
          )}
        </div>
      </Dragger>

      {/* Action Button */}
      <div className="w-full mt-6 flex justify-center">
        <PrimaryButton
          text={buttonText}
          onClick={handleButtonClick}
          loading={loading}
          className="me-[30px]"
        />
      </div>
    </Modal>
  );
}
